export default "__VITE_ASSET__BeCCcxSX__"